// Module
var code = `{{#}}
<li class="card">
  <a
    href="{{href}}"
    data-channel="ROUTE"
    data-page-id="{{pageId}}"
    data-topic-id="{{topicId}}"
    data-event-prevent-default="true"
    class="page-card"
  >
    <div class="card__image-wrapper">
      <img alt="{{attrImageAlt}}" src="{{attrImageSrc}}" class="card__image" />
    </div>
    <div class="card__content">
      <h2 class="card__title">{{title}}</h2>
      <p class="card__meta">{{meta}}</p>
      <p class="card__meta card__meta__cta">{{ctaText}}</p>
    </div>
  </a>
</li>
{{/}}
`;
// Exports
module.exports = code;